﻿import { sendDataLayer } from "./components/ecommerce/ecommerce";
import { Popup, PopupPosition } from "./utilities/popup.js";
import { CountryPopup } from "./components/countryPopup.js";
import { socialmedia } from "./components/ecommerce/socialmedia";
import "./components/account/cart.merge.ts";
import { getTranslations } from "./translations";

const mobileMediaQuery = window.matchMedia("(max-width: 768px)");

declare const UIkit: any;

if (!(window as any).initDomGeneralEnd)
{
    (window as any).initDomGeneralEnd = true;
    document.addEventListener("DOMContentLoaded", () =>
    {
        addEventListeners();

        // Init accordion
        mobileMediaQuery.addEventListener("change", initAccordion);
        mobileMediaQuery.addEventListener("change", handleSearchbarPosition);
        initPasswordToggle();
        initAccordion();
        accountMenu();
        openAccordionForHash();
        const socialMedia = new socialmedia();
    });
}

if (!(window as any).loadGeneralEnd)
{
    (window as any).loadGeneralEnd = true;
    window.addEventListener("load", (event: Event) =>
    {
        initAutoComplete();
    });
}

function addEventListeners()
{
    if ($(".js-togglephonenumber").length > 0)
        $(".js-togglephonenumber").on("click", togglePhonenumber);

    if ($(".js-header-country").length > 0)
        $(".js-header-country").on("click", showCountryPopup);

    if ($("#estrategy-cc-preference").length > 0)
        $("#estrategy-cc-preference").on("click", toggleCookiesPreference)
}

function togglePhonenumber(this)
{
    if ($(this).data("phone").length > 0)
    {
        const phoneText = $(this).data("phone");
        const phoneHref = $(this).data("phone-href");

        const $old = $(this);
        const $new = $(`<a href="${phoneHref}">`);

        $.each(this.attributes, function ()
        {
            $new.attr(this.name, this.value);
        });
        $new.html($old.html());
        $new.text(phoneText);
        $old.replaceWith($new);
    }
}

let countryPopup = null;

function showCountryPopup()
{
    // countryPopup
    if (!countryPopup)
    {
        countryPopup = new Popup({
            id: "country-desktop",
            showLogo: true,
            logoCentered: true,
            content: new CountryPopup().getCountryContent(true),
            closeButton: {
                label: "sluiten"
            },
            mobilePosition: PopupPosition.fullScreen
        });
    }
    countryPopup.show();
}

function initPasswordToggle(): void
{
    const showClass = "u-password-holder--show-active";
    const passwordHolders = document.querySelectorAll<HTMLElement>(".js-password-holder");

    passwordHolders.forEach((passwordHolder) =>
    {
        const passwordToggleIcon = passwordHolder.querySelector<HTMLElement>(".js-password-icon");
        const passwordInput = passwordHolder.querySelector<HTMLInputElement>("input");

        if (passwordToggleIcon && passwordInput)
        {
            passwordToggleIcon.addEventListener("click", () =>
            {
                const showPassword = passwordHolder.classList.toggle(showClass);
                passwordInput.type = showPassword ? "text" : "password";
            });
        }
    });
}

// Named function for the click handler to allow clean removal/addition
const handleAccordionClick = (e) =>
{
    e.preventDefault();
    e.stopPropagation();

    const toggle = e.currentTarget;
    const accordion = toggle.closest(".u-accordion");
    if (!accordion) return;

    const accordionContent = accordion.querySelector(".u-accordion__content") as HTMLDivElement;
    const isFlex = accordionContent.classList.contains("u-accordion__content--flex");

    // Toggle the visual class on the accordion wrapper
    accordion.classList.toggle("is-open");

    // WCAG Logic: Check if the accordion is currently open
    const isOpen = accordion.classList.contains("is-open");

    if (isOpen && !isFlex)
    {
        $(accordionContent).slideDown();
    } else if (isOpen && isFlex)
    {
        $(accordionContent).slideDown({
            start: function ()
            {
                $(this).css({
                    display: "flex"
                });
            }
        });
    } else
    {
        $(accordionContent).slideUp();
    }

    // Dynamically update ARIA attributes for screen readers
    toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");

    // Sync the visibility state of the content panel
    const panel = accordion.querySelector("[role='region']");
    if (panel)
    {
        panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
    }
};

export const initAccordion = () =>
{
    // Select all uninitialized accordions
    const accordions = document.querySelectorAll(".u-accordion:not(.is-init)") as NodeListOf<HTMLDivElement>;

    accordions.forEach((accordion) =>
    {
        setAccordion(accordion);
        const resizeObserver = new ResizeObserver(() =>
        {
            setAccordion(accordion);
        });

        resizeObserver.observe(accordion);
    });

    const firstAccordion = document.querySelector(".u-accordion");

    if (firstAccordion && firstAccordion.classList.contains("c-favorite-item")) {
        firstAccordion.classList.toggle("is-open");
        $(firstAccordion).find(".u-accordion__content").slideDown();
    }
 
};

function openAccordionForHash()
{
    if (window.location.hash != '' && $('ul.faqs').length > 0)
    {
        var hash = window.location.hash.substring(1);
        $("ul.faqs.customer-service-faq li:not(.is-open) a.opener").each(function (index)
        {
            if (typeof ($(this).data('tag')) != typeof (undefined) &&
                $(this).data('tag').localeCompare(hash, undefined, { sensitivity: 'base' }) == 0)
            {
                // Open accordion and scroll to item
                $(this)[0].click();
                $('html, body').animate(
                    {
                        scrollTop: $(this).closest('div.col').offset().top
                    }, 1000);
                return false;
            }
        });

        // Scroll to faq overview
        if (hash == 'faq')
        {
            $('html, body').animate(
                {
                    scrollTop: $('.k-main__faqs').offset().top - $('.w-header').height()
                }, 1000);
        }
    }
}

const setAccordion = (accordion: HTMLDivElement) =>
{
    accordion.classList.add("is-init");
    const isMobileOnly = accordion.classList.contains("u-accordion--mobile");
    const shouldActivate = (isMobileOnly && mobileMediaQuery.matches) || !isMobileOnly;

    if (shouldActivate)
    {
        accordion.classList.add("u-accordion__active");

        const toggle = accordion.querySelector(".js-accordion__toggle");
        if (toggle)
        {
            // Safely remove any existing listener first to prevent duplicates, then add it
            toggle.removeEventListener("click", handleAccordionClick);
            toggle.addEventListener("click", handleAccordionClick);
        }
    } else
    {
        accordion.classList.remove("u-accordion__active");

        const toggle = accordion.querySelector(".js-accordion__toggle");
        if (toggle)
        {
            toggle.removeEventListener("click", handleAccordionClick);
        }
    }
}

(window as any).initAccordion = initAccordion;

//#region Search suggestion

function searchPopularClick(e: JQuery, event?: Event): void 
{
    if (event)
        event.preventDefault();

    const text: string = e.text();

    if (text && text.trim() !== '') 
    {
        const $searchbar = e.closest(".c-searchbar__holder");

        $searchbar.find(".c-searchbar__suggestion li").removeClass("c-searchbar__selected-line");
        $searchbar.find(".c-searchbar__form input.c-searchbar__input").val(text);
        $searchbar.find(".c-searchbar__form .c-searchbar__button").trigger('click');
    }
}

(window as any).searchPopularClick = searchPopularClick;

//#endregion Search suggestion

//#region Search autocomplete

declare global
{
    interface JQuery
    {
        autoCompleteForm(opt?: AutoCompleteFormOptions): JQuery;
    }
}

// Autocomplete interface.
interface AutoCompleteFormOptions
{
    startCount?: number;
    dataAttr?: string;
    ajaxAttr?: string;
    listItems?: string;
    listItemsFillsInput?: boolean;
    alwaysRefresh?: boolean;
    filterResults?: boolean;
    highlightMatches?: boolean;
    selectedClass?: string;
    resultsHolder?: string;
    inputField?: string;
    hideDelay?: number;
    inputTimeout?: number;
    minimalLength?: number;
}

// JQuery plugin.
(function ($, window)
{
    $.fn.autoCompleteForm = function (this: JQuery, opt?: AutoCompleteFormOptions): JQuery
    {
        const defaults: AutoCompleteFormOptions = {
            startCount: 1,
            dataAttr: "q",
            ajaxAttr: "ajax=1",
            listItems: "li",
            listItemsFillsInput: true,
            alwaysRefresh: false,
            filterResults: true,
            highlightMatches: false,
            selectedClass: "c-searchbar__selected-line",
            resultsHolder: ".c-searchbar__suggestion",
            inputField: "input.text-input",
            hideDelay: 200,
            inputTimeout: shopConfig().autoCompleteDelay,
            minimalLength: 3
        };

        const settings = $.extend(defaults, opt);

        return this.each(function (this: HTMLElement)
        {
            const form = $(this);
            const target = form.attr("data-action") || form.attr("action") || "";
            const input = form.find(settings.inputField!).attr("autocomplete", "off");
            const ajaxHolder = $(settings.resultsHolder!).hide();

            let acXHR: JQueryXHR | null = null;
            let listItems: JQuery;
            let lastData: string = "";
            let inFocus = false;
            let focusTimer: number | null = null;
            let inputTimer: number | null = null;
            let visibleItems: JQuery;
            let visibleCount = 0;
            let currentIndex = -1;

            if (settings.filterResults)
                settings.alwaysRefresh = false;

            // Load autocomplete data.
            function loadData(callback?: () => void): void
            {
                // Abort previous request if not completed.
                if (acXHR && typeof acXHR.abort === "function")
                    acXHR.abort();

                if (inputTimer !== null)
                {
                    clearTimeout(inputTimer);
                    inputTimer = null;
                }

                const inputValue = input.val() as string;

                if (inputValue.length >= settings.minimalLength!)
                {
                    inputTimer = window.setTimeout(function ()
                    {
                        // Start new request.
                        acXHR = $.ajax({
                            url: target,
                            dataType: "text",
                            data: settings.ajaxAttr + "&" + settings.dataAttr + "=" + encodeURIComponent(inputValue),
                            success: function (msg: string)
                            {
                                // updating results
                                updateDrop(msg);
                                filterData();
                                showDrop();
                                if (typeof callback === "function") callback();
                            },
                            error: function (...args: any[])
                            {
                                // Ajax error handling.
                                if (typeof (settings as any).onerror === "function")
                                    (settings as any).onerror(...args);
                            }
                        });
                    }, settings.inputTimeout);
                }
            }

            // Filter loaded data.
            function filterData(): void
            {
                if (listItems)
                {
                    showDrop();

                    const inputValue = (input.val() as string).toLowerCase();

                    // Show only items containing input text.
                    if (settings.filterResults)
                    {
                        listItems.show().each(function (this: HTMLElement)
                        {
                            const item = $(this);
                            const origHtml = item.data("orightml") as string;

                            if (origHtml)
                                item.html(origHtml);

                            if (item.text().toLowerCase().indexOf(inputValue) !== -1)
                                item.show();
                            else
                                item.hide();
                        });

                        if (!listItems.filter(":visible").length)
                            hideDrop();
                    }

                    // Highlight matches.
                    if (settings.highlightMatches)
                    {
                        listItems.children().each(function (this: HTMLElement, i: number, obj: HTMLElement)
                        {
                            const rawValue = input.val() as string;
                            if (rawValue.length >= settings.startCount!)
                            {
                                $(obj).html(highlightWords($(obj).text(), rawValue));
                            }
                        });
                    }
                }
            }

            // Update dropdown content.
            function updateDrop(text: string): void
            {
                if (lastData !== text || window.matchMedia("(max-width: 768px)").matches)
                {
                    (lastData as any) = text;
                    currentIndex = -1;
                    ajaxHolder.html(text);
                    listItems = ajaxHolder.find(settings.listItems!);

                    listItems.each(function (this: HTMLElement)
                    {
                        // Save original html data.
                        const curItem = $(this);
                        curItem.data("orightml", curItem.html());

                        // Element click behavior.
                        curItem.on("click", function ()
                        {
                            return selectItem(curItem, true);
                        });

                        // Element hover behavior, using mouseenter (as hover is deprecated).
                        curItem.on("mouseenter", function ()
                        {
                            listItems.removeClass(settings.selectedClass!);
                            curItem.addClass(settings.selectedClass!);
                            currentIndex = listItems.filter(":visible:not(:empty)").index(curItem);
                        });

                        curItem.on("mouseleave", function ()
                        {
                            listItems.removeClass(settings.selectedClass!);
                            currentIndex = -1;
                        });
                    });
                }
            }

            // Toggle autocomplete dropdown.
            function showDrop(): void
            {
                const inputValue = input.val() as string;

                if (inputValue.length >= settings.startCount!)
                {
                    if (typeof (window as any).ShowFadeOverlay === "function")
                        (window as any).ShowFadeOverlay("#searchsuggestionoverlay");

                    ajaxHolder.show();
                    if (!listItems.filter(":visible").length)
                        hideDrop();
                } else
                    ajaxHolder.hide();
                $("div.ajax-drop").trigger("recalc");
            }

            function hideDrop(): void
            {
                ajaxHolder.hide();

                if (typeof (window as any).HideFadeOverlay === "function")
                    (window as any).HideFadeOverlay("#searchsuggestionoverlay");
                updateDrop(ajaxHolder.html());
            }

            function selectItem(obj: JQuery, realEvent?: boolean): boolean | void
            {
                if (!realEvent)
                {
                    // If selected line has an anchor, use it
                    const objAnchor = obj.find("a:eq(0)").attr("href");
                    if (objAnchor !== undefined && objAnchor.length > 0)
                    {
                        window.location.href = objAnchor;
                        return false;
                    }
                }

                if (settings.listItemsFillsInput)
                {
                    input.val(obj.text()).trigger("focus");
                    return false;
                }
            }

            // fallback container for the original input text during key navigation
            let oldSearchBarText = (input.val() as string) || "";

            // event handlers
            input.on("keyup", function (this: HTMLElement, e: JQuery.TriggeredEvent)
            {
                const key = e.which || e.keyCode;
                // skip system keys: esc, enter, up, down, tab, shift
                if (key === 27 || key === 13 || key === 38 || key === 40 || key === 9 || key === 16) return;

                const inputValue = input.val() as string;

                // load data
                if (inputValue.length < settings.startCount!) hideDrop();

                if (settings.alwaysRefresh)
                    loadData();
                else
                {
                    if (!listItems)
                        loadData();
                    filterData();
                }
            }).on("keydown", function (this: HTMLElement, e: JQuery.TriggeredEvent)
            {
                if (listItems)
                {
                    visibleItems = listItems.filter(":visible:not(:empty)");
                    visibleCount = visibleItems.length;

                    const key = e.which || e.keyCode;

                    switch (key)
                    {
                        case 13: // enter
                            if (visibleCount > 0 && currentIndex >= 0)
                                selectItem(visibleItems.eq(currentIndex));
                            break;
                        case 27: // escape
                            hideDrop();
                            break;
                        case 38: // up
                            if (currentIndex >= 0)
                            {
                                currentIndex--;

                                if (visibleItems.eq(currentIndex).hasClass("populartitle"))
                                    currentIndex--;

                                if (currentIndex < 0)
                                    input.val(oldSearchBarText);
                            }
                            break;
                        case 40: // down
                            if (currentIndex < visibleCount - 1)
                            {
                                if (currentIndex < 0)
                                    oldSearchBarText = input.val() as string;

                                if (visibleItems.eq(currentIndex).hasClass("populartitle"))
                                    currentIndex++;

                                currentIndex++;
                            }
                            break;
                    }

                    // update classes
                    listItems.removeClass(settings.selectedClass!);
                    if (currentIndex !== -1)
                        visibleItems.eq(currentIndex).addClass(settings.selectedClass!);

                    if (visibleCount > 0 && currentIndex >= 0)
                    {
                        const selectedItem = $("." + settings.selectedClass);
                        if (selectedItem.length > 0)
                        {
                            let newText = "";
                            const productText = $(selectedItem[0]).find("p").text();

                            if (productText.length > 0)
                                newText = productText;
                            else
                            {
                                const anchorText = $(selectedItem[0]).find("a").text();
                                if (anchorText.length > 0)
                                    newText = anchorText;
                            }
                            if (newText.length > 0)
                                input.val(newText);
                        }
                    }
                }
            }).on("focus", function ()
            {
                if (focusTimer !== null && !window.matchMedia("(max-width: 768px)").matches)
                    clearTimeout(focusTimer);
                inFocus = true;
            }).on("blur", function ()
            {
                inFocus = false;
                focusTimer = window.setTimeout(hideDrop, settings.hideDelay);
            });

            form.on("submit", function ()
            {
                return false;
            });
        });
    };

    // RegEx highlight.
    function escapeRegExp(str: string): string
    {
        return str.replace(new RegExp("[.*+?|()\\[\\]{}\\\\]", "g"), "\\$&");
    }

    // RegEx highlight words.
    function highlightWords(str: string, word: string): string
    {
        const regex = new RegExp("(" + escapeRegExp(word) + ")", "gi");
        return str.replace(regex, "<strong>$1</strong>");
    }
})(jQuery, window);

export const initAutoComplete = () =>
{
    var searchForm = $(".c-searchbar__form");

    if (searchForm)
    {
        if (shopConfig().autoCompleteDelay >= 0)
        {
            $(searchForm).autoCompleteForm({
                resultsHolder: ".c-searchbar__suggestion",
                inputField: ".c-searchbar__input",
                listItemsFillsInput: false,
                filterResults: false,
                alwaysRefresh: true
            });
        }
    }
}

(window as any).initAutoComplete = initAutoComplete;

//#endregion Search autocomplete

function resetButton(button: string | HTMLElement | JQuery): void
{
    // $(button).removeAttr('disabled');
    // toggleLoaderIcon(button, false);
    // setTimeout(function ()
    // {
    //     $(button).removeAttr('disabled');
    // }, 100);
}

(window as any).resetButton = resetButton;

const accountMenu = () =>
{
    if ($(".js-account-menu").length > 0)
    {
        $(".js-account-menu li").each(function ()
        {
            if (location.pathname == $(this).find("a").attr("href"))
                $(this).addClass("is-active");
        });
    }
}

//#region Cookies

let onPreference = false;

const toggleCookiesPreference = () =>
{
    const preferenceButton = document.getElementById("estrategy-cc-preference");

    if (!onPreference)
    {
        preferenceButton.innerText = getTranslations().txtGoBack;
        document.querySelector(".estrategy-cc-header").textContent = getTranslations().txtCookiesPreferences;
        document.querySelector("#estrategy-cc-reject-all").textContent = getTranslations().txtCookiesConfirm;
        onPreference = true;
    } else
    {
        preferenceButton.innerText = getTranslations().txtCookiesPreferences;
        document.querySelector(".estrategy-cc-header").textContent = getTranslations().txtCookiesTitle;
        document.querySelector("#estrategy-cc-reject-all").textContent = getTranslations().txtCookiesReject;
        onPreference = false;
    }

}

//#endregion

const handleSearchbarPosition = () => {
    const searchBar = document.querySelector(".c-searchbar");
    const searchBarHolder = document.querySelector(".c-searchbar__holder");
    const mainSection = document.querySelector(".w-main");
    const headerSection = document.querySelector(".c-header__section");

    if (!searchBar || !headerSection || !mainSection || !searchBarHolder) return;

    if (searchBar)
    {
        if (mobileMediaQuery.matches)
        {
            // mobile
            headerSection.after(searchBar);
            mainSection.classList.add("w-main--mobile");
            searchBar.classList.add("c-searchbar--mobile");
            searchBarHolder.classList.add("c-searchbar__holder--mobile");
            headerSection.classList.add("c-header__section--mobile");
        }
        else
        {
            // desktop
            headerSection.appendChild(searchBar);
            mainSection.classList.remove("w-main--mobile");
            searchBar.classList.remove("c-searchbar--mobile-shadow");
            searchBar.classList.remove("c-searchbar--mobile-hidden");
            searchBar.classList.remove("c-searchbar--mobile");
            searchBarHolder.classList.remove("c-searchbar__holder--mobile");
            headerSection.classList.remove("c-header__section--mobile");
        }
    }
}

handleSearchbarPosition()

let lastScroll = window.scrollY;
const threshold = 50;
let scrollState = "idle";
let accumulatedDelta = 0;
const minimumScrollHeight = 100;

const handleSearchbarScroll = () => {
    const searchBar = document.querySelector(".c-searchbar--mobile")
    const currentScroll = window.scrollY;
    const delta = currentScroll - lastScroll;

    if (!searchBar) return;

    if (currentScroll === 0) 
        searchBar.classList.remove("c-searchbar--mobile-shadow")
    else 
        searchBar.classList.add("c-searchbar--mobile-shadow")

    if (currentScroll <= minimumScrollHeight) {
        accumulatedDelta = 0;
        searchBar.classList.remove("c-searchbar--mobile-hidden");
        scrollState = "idle";
        return;
    }

    if (scrollState === "idle") {
        if (delta > 0)
            accumulatedDelta += delta;
        else
            accumulatedDelta = 0;

        if (accumulatedDelta >= threshold) {
            searchBar.classList.add("c-searchbar--mobile-hidden");
            scrollState = "triggered";
            accumulatedDelta = 0;
        }
    }

    if (scrollState === "triggered") {
        if (delta < 0)
            accumulatedDelta += Math.abs(delta)
        else
            accumulatedDelta = 0;

        if (accumulatedDelta >= threshold) {
            searchBar.classList.remove("c-searchbar--mobile-hidden");
            scrollState = "idle";
            accumulatedDelta = 0;
        }
    }

    lastScroll = currentScroll;
}

window.addEventListener("scroll", handleSearchbarScroll)
